export default (settings: any) => settings['rte'] * (1 / 60) * 10
